import { AccordionDesignTokens } from '@primeuix/themes/aura/accordion';

export const accordionTokens: AccordionDesignTokens = {
  panel: {
    borderWidth: '0',
    borderColor: '{content.border.color}',
  },
  header: {
    color: '{color.main.primary}',
    hoverColor: '{color.main.primary}',
    hoverBackground: '{color.brand.subtle}',
    activeColor: '{color.main.primary}',
    activeBackground: 'transparent',
    activeHoverBackground: '{color.brand.subtle}',
    padding: '0.625rem 1rem',
    fontWeight: '500',
    borderRadius: '{border.radius.md}',
    borderWidth: '0',
    borderColor: '{content.border.color}',
    background: 'transparent',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    toggleIcon: {
      color: '{color.main.tertiary}',
      hoverColor: '{color.main.tertiary}',
      activeColor: '{color.main.tertiary}',
      activeHoverColor: '{color.main.tertiary}',
    },
    first: {
      topBorderRadius: '{content.border.radius}',
      borderWidth: '0',
    },
    last: {
      bottomBorderRadius: '{content.border.radius}',
      activeBottomBorderRadius: '0',
    },
  },
  content: {
    borderWidth: '0',
    borderColor: '{content.border.color}',
    background: 'transparent',
    color: '{text.color}',
    padding: '0',
  },
  root: {
    transitionDuration: '{transition.duration}',
  },
  css: ({ dt }) => `
    .p-accordionheader .p-icon, .p-accordionheader slnk-common-icon {
      color: ${dt('color.main.tertiary')};
    }
  `,
};
